export default __webpack_public_path__ + "static/media/wh_icon_drupal.750e412c.svg";